import type { AdState } from '|>/core/addons/smartlib'

import { Events } from '|>/shared/events'
import { on, register } from '|>/shared/vjs'
import { BasePlayToggle } from '../base'

import './play-button.css'

/**
 * Central play toggle button
 * https://github.com/videojs/video.js/blob/e78bcc7b2d829fce01451cf105b918d8feec4548/src/js/control-bar/play-toggle.js
 */
@register
export class PlayButton extends BasePlayToggle {
  constructor(player, options) {
    super(player, options)

    // handleHotkeys() inside videoJs call it with BasePlayToggle.prototype - so override doesnt work
    BasePlayToggle.prototype.handleClick = this.handleClick.bind(this)
  }

  // reset button state when switching to a new channel
  @on(Events.Media.Load)
  resetBtnState() {
    this.handlePause()
  }

  @on(Events.Media.AdStateChanged)
  handleAdStateChange(adState: AdState) {
    if (adState.isAdPlaying) {
      if (this.player_.paused()) {
        this.enable()
      } else {
        this.disable()
      }
      this.handlePause()
    } else {
      // Re-enable button and restore correct state based on player
      this.enable()
      // Sync button state with actual player state
      if (this.player_.paused()) {
        this.handlePause()
      } else {
        this.handlePlay()
      }
    }
  }

  override handleClick(event) {
    if (this.player_.hasClass('vjs-ad-playing') && !this.player_.paused()) {
      return
    }

    this.player_.togglePause(event)
  }
}

PlayButton.options = {
  className: 'vjs-x-play-button',
}
